"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = __importDefault(require("react"));
var merge_1 = __importDefault(require("lodash/merge"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var moment_1 = __importDefault(require("moment"));
var core_2 = require("@material-ui/core");
var KeyboardArrowLeft_1 = __importDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var KeyboardArrowRight_1 = __importDefault(require("@material-ui/icons/KeyboardArrowRight"));
var DateRange_1 = __importDefault(require("@material-ui/icons/DateRange"));
var Event_1 = __importDefault(require("@material-ui/icons/Event"));
var AccessTime_1 = __importDefault(require("@material-ui/icons/AccessTime"));
var pickers_1 = require("@material-ui/pickers");
var moment_2 = __importDefault(require("@date-io/moment"));
// Workaround typing problems in @material-ui/pickers@3.2.3
var AnyPropsKeyboardDateTimepicker = pickers_1.KeyboardDateTimePicker;
var MaterialDateTimeControl = /** @class */ (function (_super) {
    __extends(MaterialDateTimeControl, _super);
    function MaterialDateTimeControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialDateTimeControl.prototype.render = function () {
        var _a = this.props, id = _a.id, description = _a.description, errors = _a.errors, label = _a.label, uischema = _a.uischema, visible = _a.visible, enabled = _a.enabled, required = _a.required, path = _a.path, handleChange = _a.handleChange, data = _a.data, config = _a.config;
        var appliedUiSchemaOptions = merge_1.default({}, config, uischema.options);
        var isValid = errors.length === 0;
        var inputProps = {};
        return (react_1.default.createElement(core_2.Hidden, { xsUp: !visible },
            react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: moment_2.default },
                react_1.default.createElement(AnyPropsKeyboardDateTimepicker, { id: id + '-input', label: core_1.computeLabel(core_1.isPlainLabel(label) ? label : label.default, required, appliedUiSchemaOptions.hideRequiredAsterisk), error: !isValid, fullWidth: !appliedUiSchemaOptions.trim, onFocus: this.onFocus, onBlur: this.onBlur, helperText: !isValid ? errors : description, InputLabelProps: { shrink: true }, value: data || null, onChange: function (datetime) {
                        return handleChange(path, datetime ? moment_1.default(datetime).format() : '');
                    }, format: 'MM/DD/YYYY h:mm a', clearable: true, disabled: !enabled, autoFocus: appliedUiSchemaOptions.focus, leftArrowIcon: react_1.default.createElement(KeyboardArrowLeft_1.default, null), rightArrowIcon: react_1.default.createElement(KeyboardArrowRight_1.default, null), dateRangeIcon: react_1.default.createElement(DateRange_1.default, null), keyboardIcon: react_1.default.createElement(Event_1.default, null), timeIcon: react_1.default.createElement(AccessTime_1.default, null), InputProps: inputProps }))));
    };
    return MaterialDateTimeControl;
}(react_2.Control));
exports.MaterialDateTimeControl = MaterialDateTimeControl;
exports.materialDateTimeControlTester = core_1.rankWith(2, core_1.isDateTimeControl);
exports.default = react_2.withJsonFormsControlProps(MaterialDateTimeControl);
//# sourceMappingURL=MaterialDateTimeControl.js.map